document.addEventListener("DOMContentLoaded", function () {
  var subtotalElement = document.querySelector(".totals__subtotal-value");

  function updateDisplayedValues() {
    if (subtotalElement) {
      var subtotalValue = parseFloat(
        subtotalElement.innerText.replace(/[^0-9,-]+/g, "").replace(",", ".")
      );
      var newValue100 = subtotalValue / 10;
      var newValue50 = subtotalValue / 20;
      
      // Nowe obliczenie dla 60 rat z RRSO 17,98%
      var rrso = 0.1798; // 17,98%
      var numberOfPayments = 60;
      var monthlyRate = Math.pow(1 + rrso, 1/12) - 1;
      var newValue60 = (subtotalValue * monthlyRate * Math.pow(1 + monthlyRate, numberOfPayments)) / 
                       (Math.pow(1 + monthlyRate, numberOfPayments) - 1);

      var customDisplayElement100 = document.getElementById(
        "custom-displayed-value-100"
      );
      var customDisplayElement50 = document.getElementById(
        "custom-displayed-value-50"
      );
      var customDisplayElement60 = document.getElementById(
        "custom-displayed-value-60"
      );

      if (customDisplayElement100) {
        customDisplayElement100.innerText =
          "🔢 10 rat 0% już od: " +
          newValue100.toFixed(2).replace(".", ",") +
          " PLN";
      }
      if (customDisplayElement50) {
        customDisplayElement50.innerText =
          "🔢 20 rat 0% już od: " +
          newValue50.toFixed(2).replace(".", ",") +
          " PLN";
      }
      if (customDisplayElement60) {
        customDisplayElement60.innerText =
          "🔢 do 60 rat już od: " +
          newValue60.toFixed(2).replace(".", ",") +
          " PLN miesięcznie";
      }
    }
  }

  const debouncedUpdateDisplayedValues = debounce(updateDisplayedValues, 200);

  updateDisplayedValues();

  var observer = new MutationObserver(function (mutations) {
    for (const mutation of mutations) {
      if (
        mutation.type === "characterData" ||
        (mutation.type === "childList" && mutation.target === subtotalElement)
      ) {
        debouncedUpdateDisplayedValues();
        break;
      }
    }
  });

  var config = { characterData: true, subtree: true, childList: true };

  if (subtotalElement) {
    observer.observe(subtotalElement, config);
  }

  function debounce(func, wait) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }
});